import React from 'react';
import { MAX_FILE_SIZE_MB } from '../../constants/fileUpload';

interface UploadStepProps {
  image: string | null;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const UploadStep: React.FC<UploadStepProps> = ({ image, onFileChange }) => {
  return (
    <div className="wizard-step">
      <h2>Upload Your Photo</h2>
      <p className="step-description">Choose a photo from your device to get started</p>
      <div className="upload-area-large">
        <input
          type="file"
          accept="image/*"
          onChange={onFileChange}
          className="file-input"
          id="file-input"
        />
        <label htmlFor="file-input" className={`file-label-large${image ? ' has-image' : ''}`}>
          {image ? (
            <div className="image-preview">
              <img src={image} alt="Preview" />
              <span>Change Image</span>
            </div>
          ) : (
            <div className="upload-placeholder">
              <div className="upload-icon"><i className="fas fa-camera"></i></div>
              <p>Click to upload or drag and drop</p>
              <p className="upload-hint">PNG, JPG, GIF up to {MAX_FILE_SIZE_MB}MB</p>
            </div>
          )}
        </label>
      </div>
    </div>
  );
};

export default UploadStep;
